<template>
    <div class="py-8 px-4 relative" :class="!withoutTyres ? ['pb-24', 'md:pb-8'] : []">
        <AppContainer>
            <div class="z-10">
                <slot></slot>
            </div>
        </AppContainer>

        <div class="bg-gradient-to-br from-purple-100 to-purple-200 h-full w-full absolute inset-0 -z-10"></div>

        <div v-if="!withoutTyres"
             class="bg-tyres bg-no-repeat bg-cover md:bg-contain md:bg-right-bottom w-full h-1/2 lg:h-2/3 xl:h-full absolute bottom-0 inset-x-0 -z-10 md:right-0 md:left-auto"></div>
    </div>
</template>

<script>
import AppContainer from "@/Layouts/AppContainer";

export default {
    components: {AppContainer},
    props: {
        withoutTyres: Boolean
    }
}
</script>

<style scoped>
.tyres-image {

}
</style>
